var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-price.j2"] = require( "macros/product-price.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/marketplace/marketplace-meta-shipping.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-price.j2", false, "product/templates/marketplace/marketplace-meta-shipping.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayPriceValue")) {
var t_4 = t_1.displayPriceValue;
} else {
cb(new Error("cannot import 'displayPriceValue'")); return;
}
context.setVariable("displayPriceValue", t_4);
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"selectedSku")),"sku")),"minShippingPrice");
frame.set("minShippingPrice", t_5, true);
if(frame.topLevel) {
context.setVariable("minShippingPrice", t_5);
}
if(frame.topLevel) {
context.addExport("minShippingPrice", t_5);
}
var t_6;
t_6 = runtime.contextOrFrameLookup(context, frame, "minShippingPrice") != runtime.contextOrFrameLookup(context, frame, "null") && runtime.contextOrFrameLookup(context, frame, "minShippingPrice") != runtime.contextOrFrameLookup(context, frame, "None");
frame.set("hasMinShippingPrice", t_6, true);
if(frame.topLevel) {
context.setVariable("hasMinShippingPrice", t_6);
}
if(frame.topLevel) {
context.addExport("hasMinShippingPrice", t_6);
}
var t_7;
t_7 = (lineno = 4, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["marketplace_shipping-standard-label",runtime.makeKeywordArgs({"orEmpty": runtime.contextOrFrameLookup(context, frame, "True")})]));
frame.set("fallbackText", t_7, true);
if(frame.topLevel) {
context.setVariable("fallbackText", t_7);
}
if(frame.topLevel) {
context.addExport("fallbackText", t_7);
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"selectedSku") || runtime.contextOrFrameLookup(context, frame, "fallbackText")) {
output += "\n\n    <p class=\"c-marketplace-meta__shipping\" data-qa-marketplace-meta-shipping>\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "hasMinShippingPrice") && runtime.contextOrFrameLookup(context, frame, "minShippingPrice") > 0) {
output += "\n\n            <span class=\"c-marketplace-meta__shipping-label\" data-qa-marketplace-meta-shipping-label>";
output += runtime.suppressValue((lineno = 13, colno = 103, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["marketplace_shipping-minimum-label"])), env.opts.autoescape);
output += "</span>\n\n            <span class=\"c-marketplace-meta__shipping-price\" data-qa-marketplace-meta-shipping-price>";
output += runtime.suppressValue((lineno = 15, colno = 119, runtime.callWrap(t_4, "displayPriceValue", context, [runtime.contextOrFrameLookup(context, frame, "minShippingPrice"),runtime.contextOrFrameLookup(context, frame, "core")])), env.opts.autoescape);
output += "</span>\n\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "hasMinShippingPrice") && (runtime.contextOrFrameLookup(context, frame, "minShippingPrice") == 0 || runtime.contextOrFrameLookup(context, frame, "minShippingPrice") == 0)) {
output += "\n\n            <span class=\"c-marketplace-meta__shipping-label\" data-qa-marketplace-meta-shipping-label>";
output += runtime.suppressValue((lineno = 19, colno = 103, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["marketplace_shipping-free-label"])), env.opts.autoescape);
output += "</span>\n\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "fallbackText")) {
output += "\n\n            <span class=\"c-marketplace-meta__shipping-text\" data-qa-marketplace-meta-shipping-text>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fallbackText"), env.opts.autoescape);
output += "</span>\n\n        ";
;
}
;
}
;
}
output += "\n\n    </p>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/marketplace/marketplace-meta-shipping.j2"] , dependencies)